import axios, { AxiosError } from 'axios';
import { appEnvironment } from 'pages/login/appEnvironment';

export const noInterceptorApiClient = axios.create({
  baseURL: appEnvironment.apiURL,
});
export const apiClient = axios.create({
  baseURL: `${appEnvironment.apiURL}admin/`,
});

interface SignOutController {
  signOut?: () => void;
}

interface TokenController {
  getAccessToken?: () => Promise<{ accessToken: string }>;
}

export let apiSignOutController: SignOutController = {};
export let tokenController: TokenController = {};

apiClient.interceptors.request.use(async (config) => {
  if (!config || !config.headers) {
    return config;
  }

  try {
    const session = await tokenController.getAccessToken?.();
    if (!session) {
      throw new Error('No access token');
    }

    config.headers = {
      ...config.headers,
      'Access-Token': session.accessToken,
    };

    return config;
  } catch (e) {
    if (apiSignOutController.signOut) {
      apiSignOutController.signOut();
    }
  }
});

apiClient.interceptors.response.use(
  (response) => response,
  (err) => {
    if ([401, 403].includes((err as AxiosError).response?.status ?? 0)) {
      if (apiSignOutController.signOut) {
        apiSignOutController.signOut();
      }
    }
  }
);
